import { useCallback, useState } from 'react';

/**
 * Custom hook to manage the state of table rows.
 * It's exposed via TableProvider rows are set via useTableData hook.
 * Right now they're only used to prioritize rows but it can be useful for other features too.
 *
 * @returns rows: The current rows in the table.
 * @returns updatedAt: Timestamp of the last update.
 * @returns publish: Function to update the rows and timestamp.
 */

const useTableRowsStore = <TRow,>() => {
	const [rows, setRows] = useState<TRow[]>([]);
	const [updatedAt, setUpdatedAt] = useState<number>(0);

	const publish = useCallback((newRows: TRow[], ts: number) => {
		setRows(newRows);
		setUpdatedAt(ts);
	}, []);
	return { rows, updatedAt, publish };
};

export default useTableRowsStore;
